import AccountPage from 'pages/AccountPage'
import AssetOverviewPage from 'pages/AssetOverviewPage'
import BuyListPage from 'pages/BuyListPage'
import CompleteProfilePage from 'pages/CompleteProfilePage'
import ConfirmForgotPasswordPage from 'pages/ConfirmForgotPasswordPage'
import ConfirmUserPage from 'pages/ConfirmUserPage'
import ConnectedAccountsPage from 'pages/ConnectedAccountsPage'
import ErrorPage from 'pages/ErrorPage'
import ForbiddenPage from 'pages/ForbiddenPage'
import ForgotPasswordPage from 'pages/ForgotPasswordPage'
import HomePage from 'pages/HomePage'
import InvestmentPreferencePage from 'pages/InvestmentPreferencePage'
import InvestmentTemplatesPage from 'pages/InvestmentTemplatesPage'
import ManagementOrganizationPage from 'pages/ManagementOrganizationPage'
import NotFoundPage from 'pages/NotFoundPage'
import NotificationsPage from 'pages/NotificationsPage'
// import PortfolioPage from 'pages/PortfolioPage'
import PortfolioPageV2 from 'pages/PortfolioPageV2'
import SearchPage from 'pages/SearchPage'
import SettingsPage from 'pages/SettingsPage'
import SetupMFAPage from 'pages/SetupMFAPage'
import SignInPage from 'pages/SignInPage'
import SignUpPage from 'pages/SignUpPage'
import UnderReviewPage from 'pages/UnderReviewPage'
import { Navigate, Route, Routes } from 'react-router-dom'

import PrivateRoutes from 'components/partials/PrivateRoutes'
import { usePageViews } from 'hooks/usePageViews'
import { useAppSelector } from 'store/storeHooks'

function Root() {
  const { underReview } = useAppSelector((state: any) => state.user)
  usePageViews()
  return (
    <Routes>
      <Route path="/" errorElement={<ErrorPage />}>
        <Route element={<PrivateRoutes />}>
          {underReview ? (
            <>
              <Route path="/" element={<UnderReviewPage />} />
            </>
          ) : (
            <>
              <Route index element={<HomePage />} />
              <Route
                path="/organization/:externalId"
                element={<ManagementOrganizationPage />}
              />
              <Route path="/account/:externalId" element={<AccountPage />} />
              <Route
                path="/portfolio/:externalId"
                element={<PortfolioPageV2 />}
              />
              <Route
                path="/portfolio/:externalId/v2"
                element={<PortfolioPageV2 />}
              />
              <Route
                path="/investment-preference/:externalId"
                element={<InvestmentPreferencePage />}
              />
              <Route path="/asset/:symbol" element={<AssetOverviewPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route
                path="/connected-accounts"
                element={<ConnectedAccountsPage />}
              />
              <Route
                path="/investment-templates"
                element={<InvestmentTemplatesPage />}
              />
              <Route path="/buy-lists" element={<BuyListPage />} />
              <Route path="/forbidden" element={<ForbiddenPage />} />
            </>
          )}
        </Route>
        <Route path="/login" element={<SignInPage />} />
        <Route path="/complete-profile" element={<CompleteProfilePage />} />
        <Route path="/confirm-user" element={<ConfirmUserPage />} />
        <Route path="/setup-mfa" element={<SetupMFAPage />} />
        <Route
          path="/confirm-forgot-password"
          element={<ConfirmForgotPasswordPage />}
        />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/not-found" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

export default Root
